import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgS3Icon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32.1365 14.9883L27.715 23.5878L32.1365 32.1872L33.9477 31.1531V16.0224L32.1365 14.9883Z",
			fill: "#E25444"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32.1365 14.9883L23.2935 16.0224L18.7921 23.5878L23.2935 31.1531L32.1365 32.1872V14.9883Z",
			fill: "#7B1D13"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.2906 14.9883L12.8523 15.6414V31.5341L14.2906 32.1872L23.2934 23.5878L14.2906 14.9883Z",
			fill: "#58150D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.2714 14.9702L23.3054 17.5343V29.8711L14.2714 32.1933V14.9702Z",
			fill: "#E25444"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.3102 18.889L19.4742 18.26L23.3102 13.8091L27.1366 18.26L23.3102 18.889Z",
			fill: "#58150D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.1366 18.26L23.3054 18.8986L19.4742 18.26V13.8091",
			fill: "#58150D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.3102 28.2263L19.4742 28.952L23.3102 32.774L27.1366 28.952L23.3102 28.2263Z",
			fill: "#58150D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.2934 10.4709L19.4579 12.5392V18.254L23.3053 17.1474L23.2934 10.4709Z",
			fill: "#7B1D13"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.3054 20.292L19.4742 20.7178V26.4238L23.3054 26.8716V20.292Z",
			fill: "#7B1D13"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.3054 29.9195L19.4742 28.938V34.5474L23.3054 36.5959V29.9195Z",
			fill: "#7B1D13"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.1366 28.938L23.3054 29.9197V36.5959L27.1366 34.5474V28.938Z",
			fill: "#E25444"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.3054 20.292L27.1366 20.7178V26.4238L23.3054 26.8716V20.292Z",
			fill: "#E25444"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.2935 10.4709L27.129 12.5392V18.254L23.2935 17.1655V10.4709Z",
			fill: "#E25444"
		})
	]
});
export default SvgS3Icon;
